module.exports = __webpack_public_path__ + "img/c56c123.svg";